(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-org"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retreatCarouselVid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.retreat-carousel');
  const cards = document.querySelectorAll('.video-card');
  const leftBtn = document.querySelector('.carousel-arrow.left');
  const rightBtn = document.querySelector('.carousel-arrow.right');
  const dots = document.querySelectorAll('.carousel-dots .dot');

  let index = 0;

  function updateSlide() {
    if (container) {
      container.style.transform = `translateX(-${index * 100}%)`;
    }
    updateDots();
  }

  function updateDots() {
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }

  if (leftBtn) {
    leftBtn.addEventListener('click', () => {
      if (index > 0) {
        index--;
        updateSlide();
      }
    });
  }

  if (rightBtn) {
    rightBtn.addEventListener('click', () => {
      if (index < cards.length - 1) {
        index++;
        updateSlide();
      }
    });
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      index = i;
      updateSlide();
    });
  });

  // Swipe gesture
  let startX = 0;
  let isDragging = false;

  if (container) {
    container.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    container.addEventListener('touchmove', e => {
      if (!isDragging) return;
      const currentX = e.touches[0].clientX;
      const diff = startX - currentX;

      if (diff > 50 && index < cards.length - 1) {
        index++;
        updateSlide();
        isDragging = false;
      } else if (diff < -50 && index > 0) {
        index--;
        updateSlide();
        isDragging = false;
      }
    });

    container.addEventListener('touchend', () => {
      isDragging = false;
    });
  }

  // Video modal logic
  document.querySelectorAll('.video-play-button').forEach(button => {
    button.addEventListener('click', function () {
      let videoSrc = this.getAttribute('data-video-popup');
      let embedSrc = '';

      if (!videoSrc) return;

      if (videoSrc.includes('youtube.com/shorts/')) {
        const videoId = videoSrc.split('/shorts/').pop();
        embedSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      } else if (videoSrc.includes('youtube.com') || videoSrc.includes('youtu.be')) {
        const videoId = videoSrc.includes('youtu.be')
          ? videoSrc.split('/').pop()
          : new URL(videoSrc).searchParams.get('v');
        embedSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      } else if (videoSrc.includes('vimeo.com')) {
        const videoId = videoSrc.split('/').pop();
        embedSrc = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      }

      const isExternal = embedSrc !== '';
      const modal = document.createElement('div');
      modal.style.position = 'fixed';
      modal.style.top = 0;
      modal.style.left = 0;
      modal.style.width = '100vw';
      modal.style.height = '100vh';
      modal.style.backgroundColor = 'rgba(0, 0, 0, 0.95)';
      modal.style.display = 'flex';
      modal.style.alignItems = 'center';
      modal.style.justifyContent = 'center';
      modal.style.zIndex = 1000;

      const content = isExternal
        ? `<iframe src="${embedSrc}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen style="width: 100vw; height: 100vh;"></iframe>`
        : `<video src="${videoSrc}" controls autoplay style="width: 100vw; height: 80vh; object-fit: contain;"></video>`;

      modal.innerHTML = `
        <div style="position: absolute; top: 1rem; right: 1rem; z-index: 1001;">
          <button style="background: #ED1C51; color: white; border: none; font-size: 2rem; padding: 0.25rem 0.75rem; cursor: pointer;">✕</button>
        </div>
        ${content}
      `;

      document.body.appendChild(modal);

      modal.querySelector('button').addEventListener('click', () => modal.remove());
    });
  });

  // Close modal on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const modal = document.querySelector('body > div[style*="position: fixed"]');
      if (modal) modal.remove();
    }
  });

  // Initialize
  updateSlide();
});

  } catch(e) { console.error(e); }
})();
})();
